import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Text } from '@chakra-ui/react';
import { formatDataTestId } from '@whitbread-eos/utils';
import { createElement as _createElement } from "react";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function DropdownCustomContent(_ref) {
  var _dropdownStyles$menuI;
  var isOpen = _ref.isOpen,
    onChange = _ref.onChange,
    setSelectedValue = _ref.setSelectedValue,
    setIsOpen = _ref.setIsOpen,
    options = _ref.options,
    baseDataTestId = _ref.baseDataTestId,
    dataTestId = _ref.dataTestId,
    dropdownStyles = _ref.dropdownStyles;
  var menuItemTextStyles = (_dropdownStyles$menuI = dropdownStyles === null || dropdownStyles === void 0 ? void 0 : dropdownStyles.menuItemTextStyles) !== null && _dropdownStyles$menuI !== void 0 ? _dropdownStyles$menuI : menuItemLegacyTypography;
  if (isOpen) {
    var _options$map;
    return _jsx(Box, _objectSpread(_objectSpread({}, menuListStyles), {}, {
      "data-testid": formatDataTestId(baseDataTestId, "".concat(dataTestId, "-entireList")),
      children: options === null || options === void 0 || (_options$map = options.map) === null || _options$map === void 0 ? void 0 : _options$map.call(options, (option, index) => _createElement(Box, _objectSpread(_objectSpread({}, menuItemStyles), {}, {
        "data-testid": formatDataTestId(baseDataTestId, "".concat(dataTestId, "-").concat(index)),
        key: option.id,
        role: "menuitem",
        _hover: {
          background: 'var(--chakra-colors-lightGrey5)'
        },
        _focus: {
          background: 'var(--chakra-colors-lightGrey5)'
        },
        onClick: () => {
          if (onChange) {
            onChange(option);
          }
          setSelectedValue(option);
          setIsOpen(false);
        }
      }), renderDropdownOption(option)))
    }));
  }
  return null;
  function renderDropdownOption(option) {
    return _jsxs(_Fragment, {
      children: [(option === null || option === void 0 ? void 0 : option.icon) && _jsx(Box, {
        pr: "md",
        children: option.icon
      }), _jsx(Text, _objectSpread(_objectSpread({
        as: "span"
      }, menuItemTextStyles), {}, {
        children: option === null || option === void 0 ? void 0 : option.label
      }))]
    });
  }
}
var menuItemLegacyTypography = {
  fontSize: 'var(--chakra-fontSizes-sm)',
  lineHeight: 'var(--chakra-lineHeights-1)'
};
var menuItemStyles = {
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  textAlign: 'start',
  outline: 'transparent solid 2px',
  outlineOffset: '2px',
  paddingInline: '0.8rem',
  height: 'var(--chakra-space-2xl)',
  padding: '12px var(--chakra-space-md)'
};
var menuListStyles = {
  outline: 'transparent solid 2px',
  outlineOffset: '2px',
  background: '#ffffff',
  boxShadow: '0 2px 12px var(--chakra-colors-lightGrey2)',
  minWidth: 'var(--chakra-space-full)',
  paddingTop: 'var(--chakra-space-2)',
  paddingBottom: 'var(--chakra-space-2)',
  zIndex: 1000,
  borderWidth: '2px',
  overflowY: 'scroll',
  position: 'absolute',
  top: '0px',
  paddingInline: '0px',
  width: 'var(--chakra-space-full)',
  borderColor: 'lightGrey3',
  maxHeight: '200px',
  transformOrigin: 'top left',
  opacity: 1,
  visibility: 'visible',
  transform: 'translate(0px, 57px)'
};